module.exports = __webpack_public_path__ + "static/media/taskManagement2023-10-25.55ad3a67.png";